<template>
  <print v-if="isPrint" :header="header" :board="board" :value="form"/>
  <div v-else>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      @selectField="selectField"
    />

    <!-- 사업장 개요 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 사업장 개요</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">업체명(원청)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1}}</p>
          <company-selector
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_1"
            class="w-full flex-1"
            @select="(company)=>{ form.company1 = company; form.inputA_2 = company.com_ceo}"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대표자(원청)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2}}</p>
          <ml-input
            :readonly="true"
            v-else
            v-model="form.inputA_2"
            class="w-full flex-1"
          />
        </div>
        <div></div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">업체명(하청)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3}}</p>
          <company-selector
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_3"
            class="w-full flex-1"
            @select="(company)=>{ form.company2 = company; form.inputA_4 = company.com_ceo}"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대표자(하청)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_4}}</p>
          <ml-input
            :readonly="true"
            v-else
            v-model="form.inputA_4"
            class="w-full flex-1"
          />
        </div>
        <div></div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">현장명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <ml-input
            :readonly="true"
            v-else
            v-model="form.inputA_5"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">소재지</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_6 }}</p>
          <ml-input
            :readonly="true"
            v-else
            v-model="form.inputA_6"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">공사금액</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_7 }}</p>
          <comma-input
            :readonly="true"
            v-else
            v-model="form.inputA_7"
            class="w-full flex-1"
          ></comma-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">착공일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_8 }}</p>
          <date-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputA_8"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">준공일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_9 }}</p>
          <date-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputA_9"
            :readonly="true"
          />
        </div>
        <div></div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">근로자 수</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_10 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_10"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">공정율</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_11 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_11"
            class="w-full flex-1"
          />
          <span class="ml-2">%</span>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">발주처</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_12 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_12"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center" style="align-items: start !important;">
          <div class="label-text mr-4">기술지도관계<br>(지도기관명)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_13 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_13"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center" style="align-items: start !important;">
          <div class="label-text mr-4">유해·위험방지<br>계획서 여부</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_14 }}</p>
          <div v-else class="w-full flex-1 mt-4">
            <vs-radio v-model="form.inputA_14" vs-value="대상">대상</vs-radio>
            <vs-radio class="ml-2" v-model="form.inputA_14" vs-value="비대상">비대상</vs-radio>
          </div>
        </div>
        <div class="col-span-4 flex items-center" style="align-items: start !important;">
          <div class="label-text mr-4 mt-2">공정별 공사종류</div>
          <div class="w-full flex-1">
            <div class="w-full flex-1">
              <p v-if="isPrint" class="print-input">{{ form.inputA_15 }}</p>
              <ml-input
                :readonly="board.readonly"
                v-else
                v-model="form.inputA_15"
                class="w-full flex-1"
              />
            </div>
            <div class="mt-2 w-full flex-1">
              <p v-if="isPrint" class="print-input">{{ form.inputA_16 }}</p>
              <ml-input
                :readonly="board.readonly"
                v-else
                v-model="form.inputA_16"
                class="w-full flex-1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 재해자 인적사항 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 재해자 인적사항</h5>
          <vs-col v-if="!board.readonly" class="w-auto ml-auto">
            <vs-button class="mr-4" color="secondary" @click="handleClickPush('inputB_1')">항목추가</vs-button>
            <vs-button class="mr-4" color="secondary" type="border" @click="handleClickPop('inputB_1')">마지막항목 삭제</vs-button>
          </vs-col>
        </vs-col>
      </vs-row>
      <div class="mt-4 style-table" >
        <div class="style-table-head">
          <div class="style-table-item">성명</div>
          <div class="style-table-item">주민등록번호</div>
          <div class="style-table-item">소속</div>
          <div class="style-table-item">직종</div>
          <div class="style-table-item">입사일자</div>
          <div class="style-table-item">동종경력</div>
          <div class="style-table-item">재해정도</div>
        </div>

        <div v-for="item in form.inputB_1"
          class="style-table-body">
          <!-- 성명 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.name }}</p>
            <ml-input
              :readonly="board.readonly"
              v-else
              v-model="item.name"
              class="w-full flex-1"
            />
          </div>

          <!-- 주민등록번호 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.rrn1 }} - {{ item.rrn2 }}</p>
            <div v-else style="display: flex; align-items: center;">
              <ml-input
                :readonly="board.readonly"
                v-model="item.rrn1"
                class="w-full flex-1"
              />
              <span class="mx-2">-</span>
              <ml-input
                :readonly="board.readonly"
                v-model="item.rrn2"
                class="w-full flex-1"
              />
            </div>
          </div>

          <!-- 소속 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.group }}</p>
            <ml-input
              :readonly="board.readonly"
              v-else
              v-model="item.group"
              class="w-full flex-1"
            />
          </div>

          <!-- 직종 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.typeOfWork }}</p>
            <ml-input
              :readonly="board.readonly"
              v-else
              v-model="item.typeOfWork"
              class="w-full flex-1"
            />
          </div>

          <!-- 입사일자 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.hireDate }}</p>
            <date-selector
              :readonly="board.readonly"
              v-else
              v-model="item.hireDate"
              class="w-full flex-1"
            ></date-selector>
          </div>

          <!-- 동종경력 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.workYear}}년 {{ item.workMonth }}월</p>
            <div v-else style="display: flex; align-items: center;">
              <ml-input
                :readonly="board.readonly"
                v-model="item.workYear"
                class="w-full flex-1"
              />
              <span class="mx-2">년</span>
              <ml-input
                :readonly="board.readonly"
                v-model="item.workMonth"
                class="w-full flex-1"
              />
              <span class="ml-2">월</span>
            </div>
          </div>

          <!-- 재해정도 -->
          <div class="style-table-item">
            <div v-if="isPrint" class="w-full">

            </div>
            <div v-else class="w-full">
              <div class="mb-2" style="display:flex; align-items: center;">
                <vs-checkbox :disabled="board.readonly" v-model="item.사망">사망</vs-checkbox>
                <ml-input class="ml-auto" style="width: 60px;" :readonly="board.readonly" v-model="item.사망수"/>
                <span class="ml-2">명</span>
              </div>
              <div class="mb-2" style="display:flex; align-items: center;">
                <vs-checkbox :disabled="board.readonly" v-model="item.부상">부상</vs-checkbox>
                <ml-input  class="ml-auto" style="width: 60px;" :readonly="board.readonly" v-model="item.부상수"/>
                <span class="ml-2">명</span>
              </div>
              <div style="display:flex; align-items: center;">
                <span>치료예상기간</span>
                <ml-input class="ml-auto" style="width: 60px;"  :readonly="board.readonly" v-model="item.치료예상기간"/>
                <span class="ml-2">일</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- 재해발생 내용 및 조치현황 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 재해발생 내용 및 조치현황</h5>
        </vs-col>
      </vs-row>

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">재해일시</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_1}}</p>
          <date-selector
            :readonly="board.readonly"
            v-else
            v-model="form.inputC_1"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">재해장소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_2}}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputC_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">발생형태</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_3}}</p>
          <disaster-class-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputC_3"
            :readonly="board.readonly"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">기인물</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_4}}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputC_4"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

    <!-- 재해발생개요(6하원칙) -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 재해발생개요(6하원칙)</h5>
        </vs-col>
      </vs-row>
      <div class="col-span-12 flex items-start">
        <span v-if="isPrint" class="print-textarea"> {{form.inputD_1}} </span>
        <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputD_1" :readonly="board.readonly"/>
      </div>
    </div>

    <!-- 사고후 조치사항 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 사고후 조치사항</h5>
        </vs-col>
      </vs-row>
      <div class="col-span-12 flex items-start">
        <span v-if="isPrint" class="print-textarea"> {{form.inputD_2}} </span>
        <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputD_2" :readonly="board.readonly"/>
      </div>
    </div>

    <!-- 기타 중요한 사항 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 기타 중요한 사항</h5>
        </vs-col>
      </vs-row>
      <div>
        <div class="grid" style="grid-template-columns: 140px 1fr">
          <span class="h-full flex" style="align-items: center;">산재보험 성립번호</span>
          <ml-input class="w-full" v-model="form.inputD_3" :readonly="board.readonly"/>
        </div>
        <div class="grid mt-2" style="grid-template-columns: 140px 1fr">
          <span class="h-full flex" style="align-items: center;">경찰서 조사관계</span>
          <ml-input class="w-full" v-model="form.inputD_4" :readonly="board.readonly"/>
        </div>
        <div class="grid mt-2" style="grid-template-columns: 140px 1fr">
          <span class="h-full flex" style="align-items: center;">사망사인</span>
          <ml-input class="w-full" v-model="form.inputD_5" :readonly="board.readonly"/>
        </div>
      </div>
    </div>

    <!-- 보고자 및 수신자 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 보고자 및 수신자</h5>
        </vs-col>
      </vs-row>
      <div class="grid" style="grid-template-columns: 1fr 1fr 1fr; row-gap: 0.5rem;">
        <div class="grid" style="grid-template-columns: 140px 1fr; align-items: center;">
          <div class="mr-4">보고자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_1}}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputE_1"
            class="w-full flex-1"
          />
        </div>
        <div class="grid" style="grid-template-columns: 140px 1fr; align-items: center;">
          <div class="ml-4">연락처</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_2}}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputE_2"
            class="w-full flex-1"
          />
        </div>
        <div></div>
        <div class="grid" style="grid-template-columns: 140px 1fr auto; align-items: center;">
          <div class="mr-4">수신자</div>
          <ml-input
            :readonly="board.readonly"
            v-model="form.inputE_3"
            class="w-full flex-1"
          />
          <span class="ml-2">귀하</span>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :readonly="board.readonly"
      :is-print="isPrint"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelector from '@/components/selector/FieldSelector.vue'
import Print from '@/views/boards/single-page/345/Print.vue'

export default {
  components: {
    Print,
    FieldSelector,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    DisasterClassSelector,
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          중대재해발생_사업장명: [],
          중대재해발생_재해형태: [],
        };

        value.summary["중대재해발생_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["중대재해발생_재해형태"].push({
          [this.form.inputD_3]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  created () {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  data() {
    return {
      form: {
        stdInfo: {},
        company1: {},
        company2: {},

        inputA_1: null,
        inputA_2: null,
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",
        inputA_10: "",
        inputA_11: "",
        inputA_12: "",
        inputA_13: "",
        inputA_14: "",
        inputA_15: "",
        inputA_16: "",

        inputB_1: [],

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",
        inputD_4: "",
        inputD_5: "",


        inputE_1: "",
        inputE_2: "",
        inputE_3: "",

        fileList: [],
      },
    };
  },
  methods: {
    selectField (field) {
      this.form.inputA_5 = field.field_name
      this.form.inputA_6 = field.address
      this.form.inputA_7 = field.deposit_amount
      this.form.inputA_8 = field.work_begin_at
      this.form.inputA_9 = field.work_end_at
    },
    handleClickPush (form_key) {
      if (form_key === 'inputB_1') {
        this.form[form_key].push({
          name: '',
          rrn1: '', rrn2: '',
          group: '',
          typeOfWork: '',
          hireDate: '',
          workYear: '',
          workMonth: '',
          사망: false,
          사망수: '',
          부상: false,
          부상수: '',
          치료예상기간: ''})
      }

    },
    handleClickPop (form_key) {
      this.form[form_key].pop()
    }
  }
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
  text-align: center;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>

<!-- table -->
<style scoped lang="scss">
.style-table {
  border-left:1px solid #CDCDCD; border-top:1px solid #CDCDCD;
}
.style-table-item {
  padding: 0.5rem;
  display: flex; justify-content: center; align-items: center; border-right: 1px solid #CDCDCD; border-bottom: 1px solid #CDCDCD;
}
.style-table-head,
.style-table-body {
  display: grid; grid-template-columns: 151fr 220fr 151fr 151fr 151fr 151fr 179fr;
}
.style-table-head {
  .style-table-item {
    height: 50px;
    background-color: #f9f9f9;
  }
}
</style>
